import React, { useContext, useEffect, useState } from 'react';
import { withRouter } from 'react-router-dom';
import _ from 'lodash';
import { connect } from 'react-redux';
import withForm from 'modules/common/hoc/withForm';
import Modal from 'modules/common/components/Modal';
import PropTypes from 'prop-types';
import { ModalContext } from 'App';
import * as c from '../constant';
import * as actions from '../action';

function UpdateBaseLineModal({
  history,
  data,
  updating,
  updateVeterinaryFee,
  id,
  getSingleNewBusinesses,
}) {
  const setModal = useContext(ModalContext);
  const [formData, setFormData] = useState({
    base_line: '',
  });

  const closeModal = e => {
    e.preventDefault();
    setModal({ isOpen: false });
  };

  const handleOnSubmit = e => {
    e.preventDefault();

    const args = {
      base_line: _.get(formData, 'base_line'),
    };

    return updateVeterinaryFee(id, args, () => {
      setModal({ isOpen: false });
      history.push(`/bpls/new-business/new-businesses/${id}`);
      getSingleNewBusinesses(id);
    });
  };

  const onChange = e => {
    setFormData({
      ...formData,
      [e.target.name]: e.target.value,
    });
  };

  const OnSetFormData = () => {
    setFormData({
      base_line: _.get(data, 'attributes.base_line') || '',
    });
  };

  useEffect(() => {
    if (!_.isEmpty(formData)) {
      OnSetFormData();
    }
  }, []);

  return (
    <Modal.Body>
      <form onSubmit={handleOnSubmit}>
        <div className="row">
          <div className="col-12 form-group">
            <label htmlFor="last_name" className="form-label mb-0">
              Base Line :
            </label>
            <input
              className="form-control"
              type="text"
              name="base_line"
              onChange={onChange}
              value={_.get(formData, 'base_line') || ''}
            />
          </div>
        </div>
        <div className="d-flex justify-content-center">
          <button
            disabled={updating}
            type="submit"
            className="mt-3 btn btn-primary cms-bg-color-primary cms-outline-primary mr-3"
          >
            <span className="font-weight-bold">
              {updating ? <i className="fa fa-spin fa-spinner" /> : `Submit`}
            </span>{' '}
          </button>
          <button
            disabled={updating}
            type="button"
            onClick={closeModal}
            className="mt-3 btn btn-dark "
          >
            <span className="font-weight-bold">Cancel</span>
          </button>
        </div>
      </form>
    </Modal.Body>
  );
}
UpdateBaseLineModal.defaultProps = {
  data: {},
  id: '',
};

UpdateBaseLineModal.propTypes = {
  history: PropTypes.instanceOf(Object).isRequired,
  data: PropTypes.instanceOf(Object),
  getSingleNewBusinesses: PropTypes.instanceOf(Function).isRequired,
  updating: PropTypes.bool.isRequired,
  updateVeterinaryFee: PropTypes.instanceOf(Function).isRequired,
  id: PropTypes.string,
};

const mapStateToProps = ({ api }) => ({
  updating: api.loading.indexOf(c.UPDATE_VETERINARY_FEE) > -1,
});

const enhance = _.flowRight([
  withForm,
  withRouter,
  connect(mapStateToProps, {
    ...actions,
  }),
]);

export default enhance(UpdateBaseLineModal);
